export function getPermission(url) {
    let b=false;
    let GET_PERMISSION_LIST=JSON.parse(window.localStorage.getItem("authList"));
    if(GET_PERMISSION_LIST!=null){
        for(let c of GET_PERMISSION_LIST){
            if(url == c.autUrlMethod){
               return true;
            }else{
               b=false;
            }
        }
        return b;
    }else{
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/api/authRequest.js